import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=0cc61197&lang=pug&"
import script from "./Imprint.vue?vue&type=script&lang=ts&"
export * from "./Imprint.vue?vue&type=script&lang=ts&"
import style0 from "./Imprint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
